import React from 'react'
import isEmpty from 'lodash/isEmpty'

import { TIMEZONE_OPTIONS, CALLING_HOUR_OPTIONS } from './ScheduleRetryPage'

import './ReviewLaunchPage.scss'

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const formatValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return 'Not set'
  }
  if (Array.isArray(value)) {
    return isEmpty(value) ? 'Not set' : value.join(', ')
  }
  return String(value)
}

const getOptionLabel = (options, value) => {
  const option = options.find((option) => option.value === value)
  return option ? option.label : value
}

const formatCallingDays = (days) => {
  if (!Array.isArray(days) || isEmpty(days)) {
    return 'Not set'
  }
  return days.map((day) => DAY_NAMES[day] || day).join(', ')
}

const ReviewRow = ({ label, value }) => (
  <li>
    <strong>{label}:</strong> {value}
  </li>
)

export const ReviewLaunchPage = ({ values, voiceAgentOptions, contactListOptions }) => {
  return (
    <div className="field-stack">
      <h3>Review & Launch</h3>

      <h4>Setup</h4>
      <ul className="review-launch-list">
        <ReviewRow label="Campaign Name" value={formatValue(values.name)} />
        <ReviewRow label="Description" value={formatValue(values.description)} />
        <ReviewRow
          label="AI Agent"
          value={
            values.voice_agent_id
              ? getOptionLabel(voiceAgentOptions, values.voice_agent_id)
              : 'Not set'
          }
        />
      </ul>

      <h4>Contact Lists</h4>
      <ul className="review-launch-list">
        <ReviewRow
          label="Contact Lists"
          value={
            isEmpty(values.contact_list_ids)
              ? 'Not set'
              : values.contact_list_ids
                  .map((option) => getOptionLabel(contactListOptions, option.value))
                  .join(', ')
          }
        />
      </ul>

      <h4>Schedule</h4>
      <ul className="review-launch-list">
        <ReviewRow label="Calling Days" value={formatCallingDays(values.calling_days)} />
        <ReviewRow
          label="Calling Hours"
          value={
            values.calling_hours_start && values.calling_hours_end
              ? `${getOptionLabel(CALLING_HOUR_OPTIONS, values.calling_hours_start)} - ${getOptionLabel(CALLING_HOUR_OPTIONS, values.calling_hours_end)}`
              : 'Not set'
          }
        />
        <ReviewRow
          label="Timezone"
          value={values.timezone ? getOptionLabel(TIMEZONE_OPTIONS, values.timezone) : 'Not set'}
        />
        <ReviewRow
          label="Transfer Timezone"
          value={
            values.transfer_timezone
              ? getOptionLabel(TIMEZONE_OPTIONS, values.transfer_timezone)
              : 'Not set'
          }
        />
        <ReviewRow label="Start Date" value={formatValue(values.start_date)} />
        <ReviewRow label="End Date" value={formatValue(values.end_date)} />
      </ul>

      <h4>Retry Settings</h4>
      <ul className="review-launch-list">
        <ReviewRow label="Retries (No Answer)" value={formatValue(values.retries_no_answer)} />
        <ReviewRow label="Retries (Voicemail)" value={formatValue(values.retries_voicemail)} />
        <ReviewRow label="Max Concurrent Calls" value={formatValue(values.max_concurrent_calls)} />
        <ReviewRow
          label="Interval Between Calls"
          value={values.call_interval_hours ? `${values.call_interval_hours} hours` : 'Not set'}
        />
      </ul>
    </div>
  )
}
